import type { INotifyOpts } from '@bugsnag/core';

export function logError(error: Error, opts: INotifyOpts = {}) {
  const options: INotifyOpts = {
    context: 'composer',
    ...opts,
  };

  if (window?.bugsnagClient) {
    window.bugsnagClient.notify(error, options);
  }

  // todo: consider debug library
  // eslint-disable-next-line no-console
  console.error(error, options);
}
